webpackJsonp([218244234497004],{

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudies = function CaseStudies(_ref) {
	  var caseStudies = _ref.caseStudies,
	      awards = _ref.awards,
	      cta = _ref.cta;
	  return _react2.default.createElement(
	    'div',
	    { className: 'case-studies' },
	    caseStudies.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(
	        'div',
	        { key: node.id, className: 'works-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'works-item__video' },
	          _react2.default.createElement(_heroVideo2.default, {
	            desktopPosterSrc: node.image_desktop.url,
	            mobilePosterSrc: node.image_mobile.url,
	            desktopVideoSrc: node.loop_desktop.file.url,
	            mobileVideoSrc: node.loop_mobile.file.url,
	            desktopFullVideo: node.video_desktop,
	            mobileFullVideo: node.video_mobile,
	            node: node,
	            aspectRatio: '16:9',
	            caseButton: true,
	            caseStudyVideo: true,
	            autoPlay: false,
	            loopPlay: true,
	            hoverPlay: true,
	            cta: cta
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'works-item__details' },
	          _react2.default.createElement(
	            'span',
	            { className: 'works-item__platform' },
	            node.eyebrow
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'works-item__title' },
	            node.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'works-item__description' },
	            _react2.default.createElement(
	              'p',
	              null,
	              node.description
	            )
	          ),
	          awards[node.eyebrow.toLowerCase()] ? _react2.default.createElement(
	            'div',
	            { className: 'works-item__awards' },
	            awards[node.eyebrow.toLowerCase()].map(function (award, index) {
	              return _react2.default.createElement(
	                'span',
	                { key: index.toString(), className: 'works-item__award' },
	                _react2.default.createElement('img', { src: award, alt: '' })
	              );
	            })
	          ) : null
	        )
	      );
	    })
	  );
	};
	
	CaseStudies.defaultProps = {
	  awards: {},
	  cta: 'View the work'
	};
	
	CaseStudies.propTypes = {
	  caseStudies: _propTypes2.default.array,
	  awards: _propTypes2.default.object
	};
	
	exports.default = CaseStudies;
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global graphql  */
	
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	var _scrollingBanner = __webpack_require__(97);
	
	var _scrollingBanner2 = _interopRequireDefault(_scrollingBanner);
	
	var _caseStudies = __webpack_require__(159);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MadeYouLookPage = function MadeYouLookPage(_ref) {
	  var data = _ref.data;
	
	  // Description is hardcoded here because it's too long for the field in CMS
	  var playbook = {
	    description: 'In today\'s time starved world, capturing attention is our intention.\n\nWe partnered with neuroscientists on a pioneering research study to explore how the brain actively processes information. This effort has been translated into a new playbook that shows how to create campaigns that capture attention to drive business results.'
	  };
	  playbook = _extends({}, data.drupalProject, playbook);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page page--madeyoulook' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Made You Look - ATTN:' }),
	    _react2.default.createElement(_headerNew2.default, { theme: 'dark' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero--fullbleed' },
	      _react2.default.createElement(_heroVideo2.default, {
	        desktopPosterSrc: data.drupalMedia.image_desktop.url,
	        mobilePosterSrc: data.drupalMedia.image_mobile.url,
	        desktopVideoSrc: data.drupalMedia.loop_desktop.file.url,
	        mobileVideoSrc: data.drupalMedia.loop_mobile.file.url
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'madeyoulook-intro' },
	      _react2.default.createElement(
	        'div',
	        { className: 'madeyoulook-intro__body' },
	        'If you want people to pay attention, you have to learn how to earn it by telling stories that the brain can\'t ignore.'
	      )
	    ),
	    _react2.default.createElement(_scrollingBanner2.default, { background: 'black', text: 'The playbook', length: 10 }),
	    _react2.default.createElement(
	      'div',
	      { className: 'madeyoulook-playbook' },
	      _react2.default.createElement(_caseStudies2.default, { caseStudies: [{ node: playbook }], cta: 'Watch the video' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'madeyoulook-contact' },
	      _react2.default.createElement(
	        'div',
	        { className: 'madeyoulook-contact__body' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'madeyoulook-contact__header' },
	          'Get the playbook'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'madeyoulook-contact__info' },
	          'Contact us for a digital version of our playbook or for more information on a live session for your team.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'madeyoulook-contact__email' },
	          'Email: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:madeyoulook@attn.com' },
	            'madeyoulook@attn.com'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	};
	
	MadeYouLookPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = MadeYouLookPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-madeyoulook-js-f0bc7d74a821e9a7e3b7.js